/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { getToken, removeToken, setToken } from '@/utils/token'
import { isString } from '@/utils/validate'
import { tokenName } from '@/config'
import request from '@/utils/request'
import api from '@/api'
import storage from '@/utils/storage'
import router from '@/router'
import store from '@/store'

const state = () => ({
  token: getToken(),
  username: '游客',
  avatar: 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif',
  tenant: null,
  userInfo: {},
})
const getters = {
  token: (state) => {
    state.token = getToken()
    return state.token
  },
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  //getTenantId: (state) => state.tenant.TenantId,
  //getTenant: (state) => state.tenant,
  // 2022-1-5 改成异步的了
  getTenant: async (state) => {
    let tenant = state.tenant
    if (!tenant) {
      await store.dispatch('user/GetTenantByCode').catch((e) => {
        console.log(e)
      })
      //tenant = Data
    }
    return state.tenant
  },
  getUserInfo: (state) => state.userInfo,
}
const mutations = {
  /**
   * @description 设置token
   * @param {*} state
   * @param {*} token
   */
  setToken(state, token) {
    state.token = token
    setToken(token)
  },
  /**
   * @description 用户信息
   * @param {*} state
   * @param {*} userInfo
   */
  setUserInfo(state, data) {
    state.userInfo = data
  },
  /**
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  /**
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  /**
   * @description 租户
   * @param {*} state
   * @param {*} Data
   */
  changeTenant(state, data) {
    state.tenant = data
  },
}
const actions = {
  /**
   * @description 登录拦截放行时，设置虚拟角色
   * @param {*} { commit, dispatch }
   */
  setVirtualRoles({ commit, dispatch }) {
    dispatch('acl/setFull', true, {
      root: true,
    })
    commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif')
    commit('setUsername', 'admin(未开启登录拦截)')
  },
  /**
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit }, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.login,
        method: 'PUT',
        data: params,
      })
        .then((data) => {
          const {
            Data: { [tokenName]: token, NickName, Avatar, StaffId },
          } = data
          if (token) {
            commit('setToken', token)
            // storage.set('userId', StaffId)
            // // 如不使用username用户名,可删除以下代码
            // if (NickName) commit('setUsername', NickName)
            // // 如不使用avatar头像,可删除以下代码
            // if (Avatar) commit('setAvatar', Avatar)
            resolve(data)
          } else {
            const err = `登录接口异常，未正确返回${tokenName}...`
            //Vue.prototype.$baseMessage(err, 'error', 'vab-hey-message-error')
            throw err
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  /**
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ dispatch, commit }) {
    const tenant = await store.getters['user/getTenant']
    return new Promise((resolve, reject) => {
      const params = {
        tenantId: tenant.TenantId,
        //userId: storage.get('userId'),
      }
      request({
        url: api.GetCurrentUserInfo,
        method: 'GET',
        params,
      })
        .then((data) => {
          resolve(data)
          commit('setUserInfo', data.Data)
        })
        .catch(async (e) => {
          reject(e)
          await dispatch('logout')
        })
    })
  },
  /**
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    // await logout()
    await dispatch('resetAll')
  },
  /**
   * @description 重置token、roles、ability、router、tabsBar等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ commit, dispatch }) {
    await dispatch('setToken', '')
    removeToken()
    setTimeout(() => {
      location.reload()
    }, 300)
  },
  /**
   * @description 设置token
   * @param {*} { commit }
   * @param {*} token
   */
  setToken({ commit }, token) {
    commit('setToken', token)
  },
  /**
   * @description 设置头像
   * @param {*} { commit }
   * @param {*} avatar
   */
  setAvatar({ commit }, avatar) {
    commit('setAvatar', avatar)
  },

  /**
   * 获取租户信息
   * @date 2021-08-20
   * @param {any} context
   * @param {any} params
   * @returns {any}
   */
  GetTenantByCode({ commit }, params) {
    let pathname = location.pathname.split('/')
    let tenantCode = pathname[1]
    if (!tenantCode) {
      tenantCode = api.defaultTenant
    }
    if (tenantCode == 'wwww') {
      tenantCode = 'www'
    }
    return new Promise((resolve, reject) => {
      const { Code, Data, Message } = request({
        url: api.GetTenantByCode,
        method: 'GET',
        params: { code: tenantCode },
      })
        .then(({ Code, Data, Message }) => {
          if (Code === 0) {
            resolve({ Code, Data, Message })
            commit('changeTenant', Data)
          } else {
            reject({ Code, Data, Message })
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  /**
   * 获取用户信息
   * @date 2021-08-20
   * @param {any} context
   * @param {any} params
   * @returns {any}
   */
  UserInfo(context, params) {
    return request({
      url: api.GetUserInfo,
      method: 'GET',
      params,
    })
  },
  GetCurrentUserInfo(context, params) {
    return request({
      url: api.GetCurrentUserInfo,
      method: 'GET',
      params,
    })
  },
  /**
   * 获取微信appId
   * @date 2021-08-20
   * @param {any} context
   * @param {any} params
   * @returns {any}
   */
  WechatGetAppID(context, params) {
    return request({
      url: api.WechatGetAppID,
      method: 'GET',
      params,
    })
  },

  /**
   * 通过微信code获取token
   * @date 2021-08-20
   * @param {any} context
   * @param {any} params
   * @returns {any}
   */
  WechatAuthor(context, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.WechatAuthor,
        method: 'POST',
        data: params,
      })
        .then((data) => {
          if (data.Code === 0) {
            storage.set('userId', data.Data.userId)
            context.commit('setToken', data.Data.Token)
          }
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  UserUpdateAvatar(context, params) {
    return request({
      url: api.UserUpdateAvatar,
      method: 'PATCH',
      data: params,
    })
  },
  GetUserInfoByAccount(context, params) {
    return request({
      url: api.GetUserInfoByAccount,
      method: 'GET',
      params,
    })
  },
  UserUpdateUserInfo(context, params) {
    return request({
      url: api.UserUpdateUserInfo,
      method: 'PATCH',
      data: params,
    })
  },

  QueryStaffList(context, params) {
    return request({
      url: api.QueryStaffList,
      method: 'GET',
      params,
    })
  },

  StaffRoleGetRightList(context, params) {
    return request({
      url: api.StaffRoleGetRightList,
      method: 'GET',
      params,
    })
  },

  StaffRegister(context, params) {
    return request({
      url: api.StaffRegister,
      method: 'POST',
      data: params,
    })
  },

  StaffDeregister(context, params) {
    return request({
      url: api.StaffDeregister,
      method: 'DELETE',
      data: params,
    })
  },

  UserRegister(context, params) {
    return request({
      url: api.UserRegister,
      method: 'POST',
      data: params,
    })
  },

  UserAddByWX(context, params) {
    return new Promise((resolve, reject) => {
      return request({
        url: api.UserAddByWX,
        method: 'PUT',
        data: params,
      })
        .then((data) => {
          if (data.Code === 0) {
            storage.set('userId', data.Data)
          }
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  UserWxLogin(context, params) {
    return new Promise((resolve, reject) => {
      return request({
        url: api.UserWxLogin,
        method: 'PUT',
        data: params,
      })
        .then((data) => {
          if (data.Code === 0) {
            context.commit('setToken', data.Data.Token)
          }
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  WechatGetJSSdkInfo(context, params) {
    return request({
      url: api.WechatGetJSSdkInfo,
      method: 'POST',
      data: params,
    })
  },
  SendVerificationCode(context, params) {
    return request({
      url: api.SendVerificationCode,
      method: 'POST',
      data: params,
    })
  },
  VerificateCode(context, params) {
    return request({
      url: api.VerificateCode,
      method: 'POST',
      data: params,
    })
  },
  VerfiyAccount4SendVerificationCode(context, params) {
    return request({
      url: api.VerfiyAccount4SendVerificationCode,
      method: 'GET',
      params,
    })
  },
  WechatGetOpenAppID(context, params) {
    return request({
      url: api.WechatGetOpenAppID,
      method: 'GET',
      params,
    })
  },
  /**
   * 通过微信code获取token
   * @date 2021-08-20
   * @param {any} context
   * @param {any} params
   * @returns {any}
   */
  WechatLogin(context, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.WechatLogin,
        method: 'POST',
        data: params,
      })
        .then((data) => {
          if (data.Code === 0) {
            // storage.set('userId', data.Data.StaffId)
            // context.commit('setUserInfo', data.Data)
            context.commit('setToken', data.Data.Token)
          }
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
